import React, { useState } from "react";
import { useLoader } from "../../../context/LoaderContext";
import axios from "axios";
import { headers } from "../../../exports/exports";
import { failed, success } from "../../../hooks/useToast";

interface ContactInformationProps {
  mobilenumber: string;
  setMobileNumber: React.Dispatch<React.SetStateAction<string>>;

  whatsappnumber: string;
  setWhatsappNumber: React.Dispatch<React.SetStateAction<string>>;

  permanentAddress: string;
  setPermanentAddress: React.Dispatch<React.SetStateAction<string>>;

  city: string;
  setCity: React.Dispatch<React.SetStateAction<string>>;

  stateProvince: string;
  setStateProvince: React.Dispatch<React.SetStateAction<string>>;

  postalZipCode: number | null;
  setPostalZipCode: React.Dispatch<React.SetStateAction<number | null>>;

  country: string;
  setCountry: React.Dispatch<React.SetStateAction<string>>;

  workAddress: string;
  setWorkAddress: React.Dispatch<React.SetStateAction<string>>;

  workCity: string;
  setWorkCity: React.Dispatch<React.SetStateAction<string>>;

  workStateProvince: string;
  setWorkStateProvince: React.Dispatch<React.SetStateAction<string>>;

  workPostalZipCode: number | null;
  setWorkPostalZipCode: React.Dispatch<React.SetStateAction<number | null>>;

  workCountry: string;
  setWorkCountry: React.Dispatch<React.SetStateAction<string>>;

  memberId: number;
}

const ContactInformation: React.FC<ContactInformationProps> = ({
  mobilenumber,
  setMobileNumber,
  whatsappnumber,
  setWhatsappNumber,
  permanentAddress,
  setPermanentAddress,
  city,
  setCity,
  stateProvince,
  setStateProvince,
  postalZipCode,
  setPostalZipCode,
  country,
  setCountry,
  workAddress,
  setWorkAddress,
  workCity,
  setWorkCity,
  workStateProvince,
  setWorkStateProvince,
  workPostalZipCode,
  setWorkPostalZipCode,
  workCountry,
  setWorkCountry,
  memberId,
}) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { setLoading } = useLoader();
  const validateStep = () => {
    let newErrors: { [key: string]: string } = {};
    if (!mobilenumber) {
      newErrors.mobilenumber = "Mobile Number is required";
    } else if (!/^\d{10}$/.test(mobilenumber)) {
      newErrors.mobilenumber = "Mobile Number must be exactly 10 digits";
    }

    if (!permanentAddress)
      newErrors.permanentAddress = "Permanent Address is required";

    if (!city) newErrors.city = "City is required";
    if (!stateProvince) newErrors.stateProvince = "State/Province is required";

    if (!postalZipCode) newErrors.postalZipCode = "Postal/Zip Code is required";
    else if (postalZipCode.toString().length < 4)
      newErrors.postalZipCode =
        "Postal/Zip Code must be at least 4 digits long";

    if (!country) newErrors.country = "Country is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    if (!validateStep()) {
      return;
    }
    setLoading(true);
    try {
      const data = {
        data: {
          Mobile_Number: mobilenumber,
          WhatsAPP_Number: whatsappnumber,
          Permanent_Address: permanentAddress,
          City: city,
          State_Province: stateProvince,
          Postal_Zip_Code: postalZipCode,
          Country: country,
          Work_Address: workAddress,
          Work_City: workCity,
          Work_State_Province: workStateProvince,
          Work_Postal_Zip_Code: workPostalZipCode,
          Work_Country: workCountry,
        },
      };
      axios
        .put(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-users/${memberId}`,
          data,
          {
            headers: headers,
          }
        )
        .then(() => {
          setLoading(false);
          success();
        })
        .catch(() => failed());
    } catch (e) {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="user-card__header">
        <div className="user-card__info" style={{ marginLeft: "unset" }}>
          <h3>Contact Information</h3>
          <p className="user-card__designation">
            Update your contact informaiton
          </p>
        </div>
      </div>
      <hr />
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <input
            type="number"
            placeholder="Mobile Number*"
            name="mobilenumber"
            value={mobilenumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            className={errors.mobilenumber && "error-border"}
          />
          {errors.mobilenumber && (
            <p className="error-message">{errors.mobilenumber}</p>
          )}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <input
            type="number"
            placeholder="WhatsAPP Number"
            name="whatsappnumber"
            value={whatsappnumber}
            onChange={(e) => setWhatsappNumber(e.target.value)}
          />
        </div>
      </div>
      <div className="col-xl-12">
        <div className="become-volunteer__input">
          <input
            type="text"
            placeholder="Permanent Address*"
            name="permanentaddress"
            value={permanentAddress}
            onChange={(e) => setPermanentAddress(e.target.value)}
            className={errors.permanentAddress && "error-border"}
          />
          {errors.permanentAddress && (
            <p className="error-message">{errors.permanentAddress}</p>
          )}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <select
            name="city"
            className={`become-volunteer__select ${
              errors.city && "error-border"
            }`}
            defaultValue=""
            value={city}
            onChange={(e) => setCity(e.target.value)}
          >
            <option value="" disabled>
              City*
            </option>
            <option value="Kathmandu">Kathmandu</option>
          </select>
          {errors.city && <p className="error-message">{errors.city}</p>}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <select
            name="stateprovince"
            className={`become-volunteer__select ${
              errors.stateProvince && "error-border"
            }`}
            defaultValue=""
            value={stateProvince}
            onChange={(e) => setStateProvince(e.target.value)}
          >
            <option value="" disabled>
              State/Province*
            </option>
            <option value="Bagmati">Bagmati</option>
          </select>
          {errors.stateProvince && (
            <p className="error-message">{errors.stateProvince}</p>
          )}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <input
            type="number"
            placeholder="Postal/Zip Code*"
            name="postalzipcode"
            value={postalZipCode || ""}
            onChange={(e) => setPostalZipCode(Number(e.target.value))}
            className={errors.postalZipCode && "error-border"}
          />
          {errors.postalZipCode && (
            <p className="error-message">{errors.postalZipCode}</p>
          )}
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <select
            name="country"
            className={`become-volunteer__select ${
              errors.country && "error-border"
            }`}
            defaultValue=""
            value={country}
            onChange={(e) => setCountry(e.target.value)}
          >
            <option value="" disabled>
              Country*
            </option>
            <option value="Nepal">Nepal</option>
          </select>
          {errors.country && <p className="error-message">{errors.country}</p>}
        </div>
      </div>
      <div className="col-xl-12">
        <div className="become-volunteer__input">
          <input
            type="text"
            placeholder="Work Address"
            name="workaddress"
            value={workAddress}
            onChange={(e) => setWorkAddress(e.target.value)}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <select
            name="city"
            className="become-volunteer__select"
            defaultValue=""
            value={workCity}
            onChange={(e) => setWorkCity(e.target.value)}
          >
            <option value="" disabled>
              City
            </option>
            <option value="Kathmandu">Kathmandu</option>
          </select>
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <select
            name="stateprovince"
            className="become-volunteer__select"
            defaultValue=""
            value={workStateProvince}
            onChange={(e) => setWorkStateProvince(e.target.value)}
          >
            <option value="" disabled>
              State/Province
            </option>
            <option value="Bagmati">Bagmati</option>
          </select>
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <input
            type="number"
            placeholder="Postal/Zip Code"
            name="postalzipcode"
            value={workPostalZipCode || ""}
            onChange={(e) => setWorkPostalZipCode(Number(e.target.value))}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="become-volunteer__input">
          <select
            name="country"
            className="become-volunteer__select"
            defaultValue=""
            value={workCountry}
            onChange={(e) => setWorkCountry(e.target.value)}
          >
            <option value="" disabled>
              Country
            </option>
            <option value="Nepal">Nepal</option>
          </select>
        </div>
      </div>
      <div className="become-volunteer__btn-box" style={{ textAlign: "end" }}>
        <button
          type="submit"
          className="thm-btn become-volunteer__btn become-volunteer__submit"
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default ContactInformation;
